import { action } from "satcheljs";

export interface SetDateFormatActionMessage {
    dateFormat: string;
}
export const setDateFormat: (dateFormat: string) => SetDateFormatActionMessage = action("setDateFormat", (dateFormat: string): SetDateFormatActionMessage => ({ dateFormat }));
export interface SetTimeFormatActionMessage {
    timeFormat: string;
}
export const setTimeFormat: (timeFormat: string) => SetTimeFormatActionMessage = action("setTimeFormat", (timeFormat: string): SetTimeFormatActionMessage => ({ timeFormat }));
export interface SetLocalTimeZoneActionMessage {
    timeZone: string | undefined;
    isLocalUpdate: boolean | undefined;
}
export const setLocalTimeZone: (timeZone: string | undefined, isLocalUpdate?: boolean) => SetLocalTimeZoneActionMessage = action("setLocalTimeZone", (timeZone: string | undefined, isLocalUpdate?: boolean): SetLocalTimeZoneActionMessage => ({
    timeZone,
    isLocalUpdate,
}));
